<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VRadioWithBlockLabel from "../../Form/Survey/VRadioWithBlockLabel.vue";

import { useForm } from "@inertiajs/vue3";
import intus from "@/Plugins/intus";
import { isRequired } from "intus/rules";
import VSelectTextBlockWithLabel from "../../Form/Survey/VSelectTextBlockWithLabel.vue";
import { scrollOnError } from "@/Helpers/validation";
import VSelectDefaultTextWithBlockLabel from "../../Form/Survey/VSelectDefaultTextWithBlockLabel.vue";

const props = defineProps({
    additional: Object,
    isShowSubmit: {
        Type: Boolean,
        default: true,
    },
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    did_you_take_a_direct_or_connecting_flight_to_sabah:
        answers?.did_you_take_a_direct_or_connecting_flight_to_sabah,
    arrival_from_which_airport: answers?.arrival_from_which_airport,
    which_airline_did_you_board_on_to_enter_sabah:
        answers?.which_airline_did_you_board_on_to_enter_sabah,
});

form.setError(props.additional.errors);

const emits = defineEmits("onNext");

const handleClickNext = () => {
    const validation = intus.validate(
        form.data(),
        {
            did_you_take_a_direct_or_connecting_flight_to_sabah: [isRequired()],
            arrival_from_which_airport: [isRequired()],
            which_airline_did_you_board_on_to_enter_sabah: [isRequired()],
        },
        {
            ...intus.messages,
            did_you_take_a_direct_or_connecting_flight_to_sabah:
                surveyFields[
                    "did_you_take_a_direct_or_connecting_flight_to_sabah"
                ]?.name,
            arrival_from_which_airport:
                surveyFields["arrival_from_which_airport"]?.name,
            which_airline_did_you_board_on_to_enter_sabah:
                surveyFields["which_airline_did_you_board_on_to_enter_sabah"]
                    ?.name,
        }
    );

    form.clearErrors();
    if (validation.passes()) {
        emits("onNext", form.data());
    } else {
        form.setError(validation.errors());
        setTimeout(() => scrollOnError(), 300);
    }
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <VRadioWithBlockLabel
                        elId="did_you_take_a_direct_or_connecting_flight_to_sabah"
                        v-model:value="
                            form.did_you_take_a_direct_or_connecting_flight_to_sabah
                        "
                        :label="
                            surveyFields[
                                'did_you_take_a_direct_or_connecting_flight_to_sabah'
                            ]?.name
                        "
                        :options="
                            surveyFields[
                                'did_you_take_a_direct_or_connecting_flight_to_sabah'
                            ]?.options.map((value) => {
                                return { id: value, description: value };
                            })
                        "
                        :error="
                            form.errors
                                ?.did_you_take_a_direct_or_connecting_flight_to_sabah
                        "
                    />
                </div>
                <div class="mb-3">
                    <VSelectDefaultTextWithBlockLabel
                        elId="arrival_from_which_airport"
                        v-model:value="form.arrival_from_which_airport"
                        :label="
                            surveyFields['arrival_from_which_airport']?.name
                        "
                        :options="
                            surveyFields[
                                'arrival_from_which_airport'
                            ]?.options.map((value) => {
                                return { id: value, description: value };
                            })
                        "
                        :otherOptionLabel="
                            surveyFields['arrival_from_which_airport']?.config[
                                'other_label'
                            ]
                        "
                        :otherOptionPlaceholder="
                            surveyFields['arrival_from_which_airport']?.config[
                                'other_placehholder'
                            ]
                        "
                        :error="form.errors?.arrival_from_which_airport"
                    />
                </div>
                <div class="mb-3">
                    <VSelectDefaultTextWithBlockLabel
                        elId="which_airline_did_you_board_on_to_enter_sabah"
                        v-model:value="
                            form.which_airline_did_you_board_on_to_enter_sabah
                        "
                        :label="
                            surveyFields[
                                'which_airline_did_you_board_on_to_enter_sabah'
                            ]?.name
                        "
                        :options="
                            surveyFields[
                                'which_airline_did_you_board_on_to_enter_sabah'
                            ]?.options.map((value) => {
                                return { id: value, description: value };
                            })
                        "
                        :otherOptionLabel="
                            surveyFields[
                                'which_airline_did_you_board_on_to_enter_sabah'
                            ]?.config['other_label']
                        "
                        :otherOptionPlaceholder="
                            surveyFields[
                                'which_airline_did_you_board_on_to_enter_sabah'
                            ]?.config['other_placehholder']
                        "
                        :error="
                            form.errors
                                ?.which_airline_did_you_board_on_to_enter_sabah
                        "
                    />
                </div>
            </div>
        </div>
        <VDevider />

        <div class="text-end" v-if="isShowSubmit">
            <VButtonSubmit type="button" @onCLickSubmit="handleClickNext">
                {{ $t("public.page.survey.button.next") }}
            </VButtonSubmit>
        </div>
    </div>
</template>
